import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useRef, useCallback } from "react";
import estrellasAnimacion from "../../assets/Animaciones/sparkles.gif";
// import cardBasic from "../../assets/Credenciales/Credencial_plan_basico_Salud_365.png";
// import cardPremium from "../../assets/Credenciales/Credencial_plan_premium_Salud_365.png";

const CardEffects = ({imageBasicCard, imagePremiumCard}) => {
  const navigate = useNavigate();

  const cardBasicRef = useRef(null);
  const cardPremiumRef = useRef(null);

  // Cada tarjeta tendrá su propio requestAnimationFrame
  const frameBasicRef = useRef(null);
  const framePremiumRef = useRef(null);

  const rotationBasic = useRef({
    x: 0,
    y: 0,
  });

  const rotationPremium = useRef({
    x: 0,
    y: 0,
  });

  const handleMove = useCallback((e, cardRef, frameRef, rotation) => {

    const card = cardRef.current;
    if (!card) return;
    if (frameRef.current) {
      cancelAnimationFrame(frameRef.current);
    }

    frameRef.current = requestAnimationFrame(() => {

      const rect = card.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      const px = Math.abs((x / rect.width) * 100 - 100);
      const py = Math.abs((y / rect.height) * 100 - 100);
      const lp = 50 + (px - 50) / 1.5;
      const tp = 50 + (py - 50) / 1.5;
      const opacity = (20 + Math.abs(50 - px + (50 - py)) * 1.5) / 100;
      const rotateX = ((tp - 50) / 2) * -1;
      const rotateY = ((lp - 50) / 1.5) * 0.5;
      card.style.transition = "none";
      rotation.current.x += (rotateX - rotation.current.x) * 0.18;
      rotation.current.y += (rotateY - rotation.current.y) * 0.18;
      card.style.transform = `rotateX(${rotation.current.x}deg) rotateY(${rotation.current.y}deg)`;
      card.style.setProperty("--gradient-x", `${lp}%`);
      card.style.setProperty("--gradient-y", `${tp}%`);

      card.style.setProperty(
          "--spark-x",
          `${50 + (px - 50) / 7}%`
      );

      card.style.setProperty(
          "--spark-y",
          `${50 + (py - 50) / 7}%`
      );

      card.style.setProperty("--opacity", opacity);
    });

  }, []);

  const resetCard = useCallback((cardRef, frameRef, rotation) => {

    rotation.current.x = 0;
    rotation.current.y = 0;

    if (frameRef.current) {
      cancelAnimationFrame(frameRef.current);
      frameRef.current = null;
    }

    const card = cardRef.current;
    if (!card) return;
    card.style.transition = "transform .6s ease, box-shadow .6s ease";
    card.style.transform = "rotateX(0deg) rotateY(0deg)";
    card.style.setProperty("--gradient-x", "50%");
    card.style.setProperty("--gradient-y", "50%");
    card.style.setProperty("--spark-x", "50%");
    card.style.setProperty("--spark-y", "50%");
    card.style.setProperty("--opacity", "1");

  }, []);

	const cardBaseSx = {
    "--gradient-x": "50%",
    "--gradient-y": "50%",
    "--spark-x": "50%",
    "--spark-y": "50%",
    "--opacity": 1,

		position: "relative",
		width: { xs: "90vw", sm: "420px" },
		aspectRatio: "2550 / 1607",
		borderRadius: "5% / 7.5%",
		overflow: "hidden",
		backgroundSize: "contain",
		backgroundRepeat: "no-repeat",
		backgroundPosition: "center",
		transformStyle: "preserve-3d",
    transform: "translateZ(0)",
    backfaceVisibility: "hidden",
    WebkitBackfaceVisibility: "hidden",
		willChange: "transform, opacity, background-position",
		boxShadow: `
			-20px -20px 30px -25px #e84f98,
			20px 20px 30px -25px #ffda00,
			0 55px 35px -20px rgba(0,0,0,0.5)
		`,
		transition:
    "transform .6s ease, box-shadow .6s ease",
		"&::before": {
			content: '""',
			position: "absolute",
			inset: 0,
			zIndex: 1,
			opacity: 0.45,
			backgroundImage: `linear-gradient(115deg, transparent 20%, #ff66cc 36%, #ddccaa 43%, #69e4a5 50%, #8ec5d6 57%, #b98cce 64%, transparent 80%)`,
			backgroundPosition: "var(--gradient-x) var(--gradient-y)",
			backgroundSize: "250% 250%",
			mixBlendMode: "color-dodge",
			filter: "brightness(0.5) contrast(4.0)",
			transition: "background-position .25s linear, opacity .25s linear",
		},
    "&::after": {
    content: '""',
    position: "absolute",
    inset: 0,
    zIndex: 2,
    opacity: "var(--opacity)",
    backgroundImage: `
      url("${estrellasAnimacion}"),
      linear-gradient(125deg, rgba(255,0,132,0.3) 15%, rgba(252,164,0,0.25) 30%, rgba(255,255,0,0.2) 40%, rgba(0,255,138,0.15) 60%, rgba(0,207,255,0.25) 70%, rgba(204,76,250,0.3) 85%)
    `,
    backgroundBlendMode: "overlay",
    backgroundPosition: "var(--spark-x) var(--spark-y)",
    backgroundSize: "160%",
    mixBlendMode: "color-dodge",
    filter: "brightness(1.2) contrast(2.0)",
    transition: "background-position .25s linear, opacity .25s linear",
    },
    "&:hover": {
    boxShadow: `
      -20px -20px 30px -25px #e84f98,
      20px 20px 30px -25px #ffda00,
      -7px -7px 10px -5px #e84f98,
      7px 7px 10px -5px #ffda00,
      0 0 13px 4px rgba(255,255,255,0.3),
      0 55px 35px -20px rgba(0,0,0,0.5)
    `,
    },
	};

  return (
    <Box sx={{
      backgroundColor: "#333844",
      padding:"70px 20px"
    }}>
      <Box sx={{
        display: {sm: "inherit", md:"flex"},
        justifyContent: "center",
        perspective: "1200px",
        justifyItems: "center",
        //alignItems: "center",
      }}>
        <Box sx={{
          display: "contents",
          //perspective: "1200px",
          //minHeight: "100vh",
        }}>
            
          {/* Card Basic */}
          <Box
            ref={cardBasicRef}
            onMouseMove={(e) =>
              handleMove(
                e,
                cardBasicRef,
                frameBasicRef,
                rotationBasic
              )
            }
            onMouseLeave={() =>
              resetCard(cardBasicRef, frameBasicRef, rotationBasic)
            }
            sx={{
              ...cardBaseSx,
              backgroundImage: `url(${imageBasicCard})`,
            }}
          />

          <Box padding="25px"></Box>

          {/* Card Premium */}
          <Box
            ref={cardPremiumRef}
            onMouseMove={(e) =>
              handleMove(
                e,
                cardPremiumRef,
                framePremiumRef,
                rotationPremium
              )
            }
            onMouseLeave={() =>
              resetCard(cardPremiumRef, framePremiumRef, rotationPremium)
            }
            sx={{
              ...cardBaseSx,
              backgroundImage: `url(${imagePremiumCard})`,
            }}
          />

        </Box>
      </Box>

      <Box sx={{paddingTop:"50px", justifyItems: "center", textAlign: "center"}}>
        <Typography variant="h2" sx={{
          color:"white", 
          textAlign: "center",
          fontSize:"25px",
          maxWidth:{xs:"320px", sm:"530px", md:"550px"}
        }}>
          Conoce los grandes beneficios de nuestra membresía SALUD 365.
        </Typography>
        {/* <Button
          onClick={() => navigate("/salud365")}
          sx={{
            width: "275px",
            margin: "20px 0px 0px 0px",
            padding:"10px 4px",
            fontSize: {xs:"14px", sm:"16px"},
            bgcolor: "#ffffff",
            color: "primary.deep",
            transition: "all 1s ease", 
            borderRadius: "8px",
            textAlign: "center",
            fontWeight: 700,
            '&:hover': {
              bgcolor: "#ffda00",
              color:"primary.deep",
              transition: "all 1s ease", 
            }
          }}
        >
          Obtener más información
        </Button> */}
      </Box>
    </Box>
  );
};

export default CardEffects;
